import Core from "@/modules/core/service/Core";

const url = {
    all             : "/api/customer",
    customerById    : "/api/customer/{0}",
    companies       : "/api/customer/{0}/company",
    manager         : "/api/customer/{0}/manager",
    contracts       : "/api/customer/{0}/contract",
    assign          : "/api/customer/{0}/company/{1}",
    responsibilities: "/api/customer/{0}/responsibility"
};

export default {
    findAll (success) {
        return Core.method.get(url.all).then(data => {
            success (data);
        })
    },

    byId (customerId, success) {
        return Core.method.get(url.customerById, customerId).then(data => {
            success (data);
        })
    },

    companies (customer, success) {
        return Core.method.get(url.companies, customer).then(data => {
            success (data);
        })
    },

    manager (customer, success) {
        return Core.method.get(url.manager, customer).then(data => {
            success (data);
        })
    },

    assign (customerId, companyId) {
        return Core.method.post(url.assign, null, customerId, companyId);
    },

    unassign (customerId, companyId) {
        return Core.method.delete(url.assign, null, customerId, companyId);
    },

    contracts (customer, filter, success) {
        return Core.method.post(url.contracts, filter, customer).then(data => {
            if (success) success (data);
        })
    },

    isType(item, type) {
        if (!item.statistics) {
            return false;
        }

        const statistic = item.statistics[type];
        if(!statistic) {
            return false;
        }

        return statistic.active >= 0;
    },

    contractStatistic(item, type) {
        const statistics = item.statistics [type];
        if (!statistics) {
            return {
                active  : 0,
                inactive: 0
            }
        }

        return statistics;
    },

    responsibilities: {
        load (customerId) {
            return Core.method.get(url.responsibilities, customerId);
        },

        store (customerId, responsibility) {
            return Core.method.putVoid(url.responsibilities, responsibility, customerId);
        },

        refresh (customerId) {
            return Core.method.post(url.responsibilities, null, customerId);
        }
    },

    filter: {
        company (items, search) {
            if (!search) {
                return items;
            }

            return items.filter (company => {
                if (company.name && company.name.includes(search)) {
                    return true;
                }

                if (company.nameAdd && company.nameAdd.includes(search)) {
                    return true;
                }

                if (company.street && company.street.includes(search)) {
                    return true;
                }

                if (company.zip && company.zip.includes(search)) {
                    return true;
                }

                if (company.city && company.city.includes(search)) {
                    return true;
                }

                return false;
            });
        },
    }
}